import { CalendarTimeSlotsIntro } from '~/components';
import { FormattedTimeSlotsList } from '~/components/calendar-with-filters/time-slots/time-slots-list';
import { formatMeasureSlots as formatTimeSlots, areMeasureSlotsEqual as areSlotsEqual } from '~/components/calendar-with-filters/time-slots/helpers';

export const config = {
  Calendar: {
    calendarTimeSlotsIntro: CalendarTimeSlotsIntro,
    timeSlotsList: FormattedTimeSlotsList,
    timeSlotSectionTitle: 'Select a time',
    formatTimeSlots,
    areSlotsEqual,
  },
};
